import { AppFunctionComponent, TextWithEmbedBuilder } from "../../types"
import React, { useEffect, useState } from "react"
import GalleryUI from "../../components/common/gallery-ui/gallery-ui.component"
import HeroCarousel from "../../components/common/hero-carousel/hero-carousel.component"
import QuoteSlider from "../../components/common/quote-slider.component"
import {
  HeroBuilder,
  ListItemBuilder,
  Quote,
  ResponsiveImage,
  SliderBuilder,
  SliderLayout,
} from "../../types"
import TextWithEmbedCarousel from "../../components/common/text-with-embed-carousel/text-with-embed-carousel.component"
import TextWithEmbedCarouselStock from "../../components/common/text-with-embed-carousel-stock/text-with-embed-carousel-stock"
import TextWithEmbedSliderBorder from "../../components/common/text-with-embed-slider-border/text-with-embed-slider-border"
import TextWithEmbedSliderBorderReversed from "../../components/common/text-with-embed-slider-border/text-with-embed-slider-border-reversed"
import ArticleListSlider from "../../components/common/article-list-slider.component"

import SliderCarousel from "../../components/common/slider-carousel.components"
import Slider from "../../components/common/slider.component"

import SliderWithTitle from "../../components/common/slider-with-title.component"

const SliderResolver: AppFunctionComponent<SliderBuilder> = ({
  className,
  sliderLayout,
  embeds,
  anchorId,
  text,
  entryName,
  title,
}) => {
  const [active, setActive] = useState(0)

  useEffect(() => {
    setActive(0)
  }, [])

  const RegularImageSliderCarousel = () => (
    <SliderCarousel
      text={text}
      className={className}
      anchorId={anchorId}
      slides={(embeds as ListItemBuilder[]).map((embed) => {
        return {
          image: embed,
          description: embed.text,
        }
      })}
    />
  )

  const RegularImageSlider = () => (
    <Slider
      className={className}
      anchorId={anchorId}
      slides={(embeds as ListItemBuilder[]).map((embed) => {
        return {
          image: embed.image,
          description: embed.text,
          style: embed.style,
        }
      })}
    />
  )

  const RegularImageSliderWithTitle = () => {
    if (!title) {
      return null
    }

    return (
      <SliderWithTitle
        className={className}
        anchorId={anchorId}
        title={title}
        slides={(embeds as ListItemBuilder[]).map((embed) => {
          return {
            image: embed.image,
            description: embed.text,
          }
        })}
      />
    )
  }

  const RegularImageSliderWithTitleReversed = () => {
    if (!title) {
      return null
    }

    return (
      <SliderWithTitle
        className={className}
        anchorId={anchorId}
        rtl
        title={title}
        slides={(embeds as ListItemBuilder[]).map((embed) => {
          return {
            image: embed.image,
            description: embed.text,
          }
        })}
      />
    )
  }

  const ImageSlider = () => (
    <GalleryUI
      className={className}
      anchorId={anchorId}
      active={active}
      onActiveChange={setActive}
      images={embeds as ResponsiveImage[]}
    />
  )

  const QuoteTextSlider = () => (
    <QuoteSlider
      anchorId={anchorId}
      slides={embeds as Quote[]}
      className={className}
    />
  )

  const ArticleTextListSlider = () => (
    <ArticleListSlider
      anchorId={anchorId}
      text={text}
      slides={embeds as Quote[]}
      className={className}
      title={entryName}
    />
  )

  const CarouselHeroSlider = () => (
    <HeroCarousel
      anchorId={anchorId}
      slides={embeds as HeroBuilder[]}
      className={className}
    />
  )

  const TextWithEmbedSlider = () => (
    <TextWithEmbedCarousel
      anchorId={anchorId}
      text={text}
      slides={embeds as HeroBuilder[]}
      className={className}
      isArrowsDisabled
    />
  )

  const TextWithEmbedSliderStock = () => (
    <TextWithEmbedCarouselStock
      anchorId={anchorId}
      text={text}
      slides={embeds as unknown as TextWithEmbedBuilder[]}
      className={className}
      isArrowsDisabled
    />
  )

  const TextWithEmbedSliderBorderComponent = () => (
    <TextWithEmbedSliderBorder
      anchorId={anchorId}
      slides={embeds as unknown as TextWithEmbedBuilder[]}
      className={className}
      text={text}
      isArrowsDisabled
    />
  )

  const TextWithEmbedSliderBorderReversedComponent = () => (
    <TextWithEmbedSliderBorderReversed
      anchorId={anchorId}
      slides={embeds as unknown as TextWithEmbedBuilder[]}
      className={className}
      text={text}
      isArrowsDisabled
    />
  )

  switch (sliderLayout) {
    case SliderLayout.RegularImageSlider:
      return <RegularImageSlider />
    case SliderLayout.RegularImageSliderCarousel:
      return <RegularImageSliderCarousel />
    case SliderLayout.RegularImageSliderWithTitle:
      return <RegularImageSliderWithTitle />
    case SliderLayout.RegularImageSliderWithTitleReversed:
      return <RegularImageSliderWithTitleReversed />

    case SliderLayout.ProductImageSlider:
      return <ImageSlider />
    case SliderLayout.QuoteSlider:
      return <QuoteTextSlider />
    case SliderLayout.MultiHero:
      return <CarouselHeroSlider />
    case SliderLayout.TextWithEmbedSlider:
      return <TextWithEmbedSlider />
    case SliderLayout.TextWithEmbedSliderStock:
      return <TextWithEmbedSliderStock />
    case SliderLayout.ArticleListSlider:
      return <ArticleTextListSlider />
    case SliderLayout.TextWithEmbedSliderBorder:
      return <TextWithEmbedSliderBorderComponent />
    case SliderLayout.TextWithEmbedSliderBorderReversed:
      return <TextWithEmbedSliderBorderReversedComponent />
    default:
      return null
  }
}

export default SliderResolver
